import { BackgroundCheckStatus } from '@/backend/features/background-check/types';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import SafetyCheckIcon from '@juvare/common-web-ui/icons/SafetyCheck';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import ErrorIcon from '@mui/icons-material/Error';
import RemoveModeratorIcon from '@mui/icons-material/RemoveModerator';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

type IconDetails = { Icon: React.ComponentType; color: string };

type BackgroundCheckIcon =
    | 'verified-user-icon-green'
    | 'remove-moderator-icon-red'
    | 'add-moderator-icon-neutral'
    | 'safety-check-icon-blue'
    | 'error-icon-red';

export const iconNameToIconDetailsMap = {
    'verified-user-icon-green': {
        Icon: VerifiedUserIcon,
        color: themeColors.accent.green.base,
    },
    'remove-moderator-icon-red': {
        Icon: RemoveModeratorIcon,
        color: themeColors.accent.red.base,
    },
    'add-moderator-icon-neutral': {
        Icon: AddModeratorIcon,
        color: themeColors.accent.grey.base,
    },
    'safety-check-icon-blue': {
        Icon: SafetyCheckIcon,
        color: themeColors.accent.blue.base,
    },
    'error-icon-red': {
        Icon: ErrorIcon,
        color: themeColors.accent.red.base,
    },
} satisfies Record<BackgroundCheckIcon, IconDetails>;

export const backgroundCheckStatusToIconNameMap: Record<BackgroundCheckStatus | 'statusNotDefined', BackgroundCheckIcon> = {
    completeClear: 'verified-user-icon-green',
    completeDenied: 'remove-moderator-icon-red',
    didNotConsent: 'remove-moderator-icon-red',
    formIncomplete: 'remove-moderator-icon-red',
    invalidSsn: 'add-moderator-icon-neutral',
    missingFields: 'remove-moderator-icon-red',
    processingError: 'remove-moderator-icon-red',
    processingNeedsAttention: 'remove-moderator-icon-red',
    processingPending: 'safety-check-icon-blue',
    processingResearching: 'safety-check-icon-blue',
    processingSubmitted: 'safety-check-icon-blue',
    readyToSubmit: 'add-moderator-icon-neutral',
    reviewAndTakeAction: 'add-moderator-icon-neutral',
    unknown: 'remove-moderator-icon-red',
    statusNotDefined: 'error-icon-red',
};

export const backgroundCheckStatusToIconMap = {
    completeClear: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.completeClear],
    completeDenied: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.completeDenied],
    didNotConsent: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.didNotConsent],
    formIncomplete: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.formIncomplete],
    invalidSsn: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.invalidSsn],
    missingFields: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.missingFields],
    processingError: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.processingError],
    processingNeedsAttention: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.processingNeedsAttention],
    processingPending: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.processingPending],
    processingResearching: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.processingResearching],
    processingSubmitted: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.processingSubmitted],
    readyToSubmit: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.readyToSubmit],
    reviewAndTakeAction: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.reviewAndTakeAction],
    unknown: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.unknown],
    statusNotDefined: iconNameToIconDetailsMap[backgroundCheckStatusToIconNameMap.statusNotDefined],
} satisfies Record<BackgroundCheckStatus | 'statusNotDefined', IconDetails>;
